'use strict';

$('.donation-form-download a').click((e) => {
  window.open(e.target.dataset.href);
  return false;
});
